import { render, staticRenderFns } from "./wxPayAmountActivity.vue?vue&type=template&id=2496794c"
import script from "./wxPayAmountActivity.vue?vue&type=script&lang=js"
export * from "./wxPayAmountActivity.vue?vue&type=script&lang=js"
import style0 from "./wxPayAmountActivity.vue?vue&type=style&index=0&id=2496794c&prod&lang=scss"
import style1 from "./wxPayAmountActivity.vue?vue&type=style&index=1&id=2496794c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports